__turbopack_context__.v({
  "animation": "Badge-module-scss-module__rQQlyq__animation",
  "shineDefault": "Badge-module-scss-module__rQQlyq__shineDefault",
  "shineHover": "Badge-module-scss-module__rQQlyq__shineHover",
});
